import React, { useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { FiChevronDown } from 'react-icons/fi';
import { useCompactLayout } from './ResponsiveRows';

const ResponsiveBootstrapTable = ({ columns, renderSummary, ...props }) => {
  const compact = useCompactLayout();
  const [sort, setSort] = useState();
  const [expanded, setExpanded] = useState([]);
  const responsiveColumns = columns.map((column) => ({
    ...column,
    hidden: compact,
    onSort: (dataField, order) => setSort({ dataField, order }),
  }));
  if (compact) responsiveColumns.push({
    dataField: '__summary',
    isDummyField: true,
    text: 'Summary',
    formatter: (_, row) => <div className="responsive-row-summary">{renderSummary(row)}</div>,
  });

  return (
    <div className={`legacy-responsive-table${compact ? ' is-compact' : ''}`}>
      {compact && <div className="shortlinks-toolbar">
        <label>Sort by
          <select aria-label="Sort by" value={sort?.dataField || ''} onChange={(event) => setSort({ dataField: event.target.value, order: sort?.order || 'asc' })}>
            <option value="" disabled>Select column</option>
            {columns.filter((column) => column.sort).map((column) => <option key={column.dataField} value={column.dataField}>{column.text}</option>)}
          </select>
        </label>
        <select aria-label="Sort direction" value={sort?.order || 'asc'} disabled={!sort} onChange={(event) => setSort({ ...sort, order: event.target.value })}>
          <option value="asc">Ascending</option><option value="desc">Descending</option>
        </select>
      </div>}
      <BootstrapTable
        {...props}
        columns={responsiveColumns}
        sort={sort}
        expandRow={{
          expanded: compact ? expanded : [],
          nonExpandable: compact ? [] : props.data.map((row) => row[props.keyField]),
          showExpandColumn: compact,
          expandColumnPosition: 'right',
          expandByColumnOnly: true,
          onExpand: (row, isExpanded) => setExpanded((current) => isExpanded
            ? [...current, row[props.keyField]]
            : current.filter((rowId) => rowId !== row[props.keyField])),
          expandColumnRenderer: ({ expanded: isExpanded }) => <button type="button" className="shortlinks-copy" aria-label={isExpanded ? 'Collapse row details' : 'Expand row details'} aria-expanded={isExpanded}><FiChevronDown aria-hidden="true" /></button>,
          expandHeaderColumnRenderer: () => null,
          renderer: (row) => <dl className="legacy-row-details">{columns.map((column) => (
            <div key={column.dataField}><dt>{column.text}</dt><dd>{column.formatter
              ? column.formatter(row[column.dataField], row, props.data.indexOf(row))
              : row[column.dataField] ?? '-'}</dd></div>
          ))}</dl>,
        }}
      />
    </div>
  );
};

export default ResponsiveBootstrapTable;